<!-- 默认的条款内容 -->
<template>
  <div class="article-content">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
      <!--相关保证金-->
      <p class="font-s-pf">{{$t('applyTradeAccount.aboutMargin')}}</p>
      <el-row class="mt-10">
        <el-form-item>
          <el-checkbox @change="changeAboutMargin1" v-model="ruleForm.aboutMargin[0].checked">
            <span class="font-s-pf">
              {{$t('applyTradeAccount.aboutMarginTitle1')}}
            </span>
          </el-checkbox>
        </el-form-item>
      </el-row>
      <el-row :gutter="20" class="mt-10" v-show="!ruleForm.aboutMargin[0].checked">
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
          <el-form-item prop="aboutMargin1AccountName" :label="$t('applyTradeAccount.aboutMarginAccountName')">
            <el-input  type="text" v-model="ruleForm.aboutMargin[0].accountHolder" :placeholder="$t('applyTradeAccount.pleaseInput')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
          <el-form-item prop="aboutMargin1AccountNumber" :label="$t('applyTradeAccount.aboutMarginAccountNumber')">
            <el-input type="text" v-model="ruleForm.aboutMargin[0].accountNumber" :placeholder="$t('applyTradeAccount.pleaseInput')"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="mt-10">
        <el-form-item>
          <el-checkbox @change="changeAboutMargin2" v-model="ruleForm.aboutMargin[1].checked">
            <span class="font-s-pf">
              {{$t('applyTradeAccount.aboutMarginTitle2')}}
            </span>
          </el-checkbox>
        </el-form-item>
      </el-row>
      <el-row :gutter="20" class="mt-10" v-show="!ruleForm.aboutMargin[1].checked">
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
          <el-form-item prop="aboutMargin2AccountName" :label="$t('applyTradeAccount.aboutMarginAccountName')">
            <el-input type="text" :placeholder="$t('applyTradeAccount.pleaseInput')" v-model="ruleForm.aboutMargin[1].accountHolder"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
          <el-form-item prop="aboutMargin2AccountNumber" :label="$t('applyTradeAccount.aboutMarginAccountNumber')">
            <el-input type="text" :placeholder="$t('applyTradeAccount.pleaseInput')" v-model="ruleForm.aboutMargin[1].accountNumber"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="mt-10">
        <el-form-item>
          <el-checkbox @change="changeAboutMargin3" v-model="ruleForm.aboutMargin[2].checked">
            <span class="font-s-pf">
              {{$t('applyTradeAccount.aboutMarginTitle3')}}
            </span>
          </el-checkbox>
        </el-form-item>
      </el-row>
      <el-row :gutter="20" class="mt-10" v-show="!ruleForm.aboutMargin[2].checked">
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
          <el-form-item prop="aboutMargin3AccountName" :label="$t('applyTradeAccount.aboutMarginAccountName')">
            <el-input type="text" :placeholder="$t('applyTradeAccount.pleaseInput')" v-model="ruleForm.aboutMargin[2].accountHolder"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
          <el-form-item prop="aboutMargin3AccountNumber" :label="$t('applyTradeAccount.aboutMarginAccountNumber')">
            <el-input type="text" :placeholder="$t('applyTradeAccount.pleaseInput')" v-model="ruleForm.aboutMargin[2].accountNumber"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <hr/>
      <!--阅读条款-->
      <el-row class="mt-10">
        <el-form-item prop="checked1">
          <el-checkbox v-model="ruleForm.checked1" test_id= "checkbox1">
            <span class="font-s-pf">
              {{$t('applyTradeAccount.infomationTips.haveRead')}}
            </span>
          </el-checkbox>
          <a :href="$t('applyTradeAccount.infomationTips.rulesLink')" target="_blank">
            <span class="statement">{{$t('applyTradeAccount.infomationTips.rules')}}</span>
          </a>
        </el-form-item>
      </el-row>
      <el-row class="mt-10">
        <el-form-item prop="checked2">
          <el-checkbox v-model="ruleForm.checked2" test_id= "checkbox2">
            <span class="font-s-pf">
              {{$t('applyTradeAccount.infomationTips.haveRead')}}
            </span>
          </el-checkbox>
          <a :href="$t('applyTradeAccount.infomationTips.statementLink')" target="_blank">
            <span class="statement">{{$t('applyTradeAccount.infomationTips.statement')}}</span>
          </a>
        </el-form-item>
      </el-row>
      <el-row class="mt-10">
        <el-form-item prop="checked3">
          <el-checkbox v-model="ruleForm.checked3" test_id= "checkbox3">
            <span class="font-s-pf">
              {{$t('applyTradeAccount.infomationTips.textOne')}}
            </span>
          </el-checkbox>
          <a :href="$t('applyTradeAccount.infomationTips.linkOne')" target="_blank">
            <span class="statement">{{$t('applyTradeAccount.infomationTips.linkOneText')}}</span>
          </a>
          <span class="font-s-pf">{{$t('applyTradeAccount.infomationTips.textTwo')}}</span>
          <a :href="standingLink" target="_blank">
            <span class="statement">{{$t('applyTradeAccount.infomationTips.linkTwoText')}}</span>
          </a>
          <span class="font-s-pf">{{$t('applyTradeAccount.infomationTips.lastText')}}</span>
        </el-form-item>
      </el-row>
      <el-row class="mt-10" v-if="isMainland">
        <el-form-item prop="checked4">
          <el-checkbox v-model="ruleForm.checked4" test_id= "checkbox4">
            <span class="font-s-pf">
              {{$t('applyTradeAccount.complianceDeclarationTextOne')}}
            </span>
          </el-checkbox>
          <a :href="$t('applyTradeAccount.declarationLink')" target="_blank">
            <span class="statement">{{$t('applyTradeAccount.declarationLinkContent')}}</span>
          </a>
          <span class="font-s-pf">{{$t('applyTradeAccount.declarationLastText')}}</span>
        </el-form-item>
      </el-row>
      <el-form-item>
        <div class="apply-btn" v-show="isShowButton">
          <el-button @click="submitForm('ruleForm')" test_id= "createAccount">
            {{status==='reject'?$t('applyTradeAccount.reSubmit'):$t('applyTradeAccount.confirm')}}
          </el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { getAgreementContent } from '@/api/v2/deposit.js'
import { mapState } from 'vuex'

export default {
  props: {
    isShowButton: {
      type: Boolean,
      default: true
    },
    status: {
      type: String,
      default: ''
    }
  },
  data () {
    let checkedVal = (rule, value, callback) => {
      let f = rule.field
      if (!this['ruleForm'][f]) {
        return callback(new Error(this.$t('applyTradeAccount.checked')))
      }
      callback()
    }
    let checkedValForMainland = (rule, value, callback) => {
      if (this.userInfo.isMainland !== 'Y' || this.userInfo.mainlandComplianceAgreed === 'Y') {
        callback()
        return
      }
      let f = rule.field
      if (!this['ruleForm'][f]) {
        return callback(new Error(this.$t('applyTradeAccount.checked')))
      }
      callback()
    }
    let checkedAboutMargin1AccountName = (rule, value, callback) => {
      if (!this.ruleForm.aboutMargin[0].checked && !this.ruleForm.aboutMargin[0].accountHolder) {
        return callback(new Error(this.$t('applyTradeAccount.aboutMarginAccountNameErr')))
      }
      callback()
    }
    let checkedAboutMargin1AccountNumber = (rule, value, callback) => {
      if (!this.ruleForm.aboutMargin[0].checked && !this.ruleForm.aboutMargin[0].accountNumber) {
        return callback(new Error(this.$t('applyTradeAccount.aboutMarginAccountNumberErr')))
      }
      let re = /^[0-9a-zA-Z]*$/ // 判断字符串是否为数字和字母组合
      if (!this.ruleForm.aboutMargin[0].checked && !re.test(this.ruleForm.aboutMargin[0].accountNumber)) {
        return callback(new Error(this.$t('applyTradeAccount.illegalMarginAccountNumber')))
      }
      callback()
    }
    let checkedAboutMargin2AccountName = (rule, value, callback) => {
      if (!this.ruleForm.aboutMargin[1].checked && !this.ruleForm.aboutMargin[1].accountHolder) {
        return callback(new Error(this.$t('applyTradeAccount.aboutMarginAccountNameErr')))
      }
      callback()
    }
    let checkedAboutMargin2AccountNumber = (rule, value, callback) => {
      if (!this.ruleForm.aboutMargin[1].checked && !this.ruleForm.aboutMargin[1].accountNumber) {
        return callback(new Error(this.$t('applyTradeAccount.aboutMarginAccountNumberErr')))
      }
      let re = /^[0-9a-zA-Z]*$/ // 判断字符串是否为数字和字母组合
      if (!this.ruleForm.aboutMargin[1].checked && !re.test(this.ruleForm.aboutMargin[1].accountNumber)) {
        return callback(new Error(this.$t('applyTradeAccount.illegalMarginAccountNumber')))
      }
      callback()
    }
    let checkedAboutMargin3AccountName = (rule, value, callback) => {
      if (!this.ruleForm.aboutMargin[2].checked && !this.ruleForm.aboutMargin[2].accountHolder) {
        return callback(new Error(this.$t('applyTradeAccount.aboutMarginAccountNameErr')))
      }
      callback()
    }
    let checkedAboutMargin3AccountNumber = (rule, value, callback) => {
      if (!this.ruleForm.aboutMargin[2].checked && !this.ruleForm.aboutMargin[2].accountNumber) {
        return callback(new Error(this.$t('applyTradeAccount.aboutMarginAccountNumberErr')))
      }
      let re = /^[0-9a-zA-Z]*$/ // 判断字符串是否为数字和字母组合
      if (!this.ruleForm.aboutMargin[2].checked && !re.test(this.ruleForm.aboutMargin[2].accountNumber)) {
        return callback(new Error(this.$t('applyTradeAccount.illegalMarginAccountNumber')))
      }
      callback()
    }
    return {
      ruleForm: {
        aboutMargin: [
          {
            relatedName: 'isMarginAccount',
            checked: true,
            accountHolder: '',
            accountNumber: ''
          },
          {
            relatedName: 'isDiscretion',
            checked: true,
            accountHolder: '',
            accountNumber: ''
          },
          {
            relatedName: 'isCompanyAccounts',
            checked: true,
            accountHolder: '',
            accountNumber: ''
          }
        ],
        checked1: false,
        checked2: false,
        checked3: false,
        checked4: false
      },
      rules: {
        aboutMargin1AccountName: { validator: checkedAboutMargin1AccountName },
        aboutMargin1AccountNumber: { validator: checkedAboutMargin1AccountNumber },
        aboutMargin2AccountName: { validator: checkedAboutMargin2AccountName },
        aboutMargin2AccountNumber: { validator: checkedAboutMargin2AccountNumber },
        aboutMargin3AccountName: { validator: checkedAboutMargin3AccountName },
        aboutMargin3AccountNumber: { validator: checkedAboutMargin3AccountNumber },
        checked1: { validator: checkedVal },
        checked2: { validator: checkedVal },
        checked3: { validator: checkedVal },
        checked4: { validator: checkedValForMainland }
      },
      standingLink: ''
    }
  },
  computed: {
    ...mapState(['userInfo']),
    isMainland() {
      return this.userInfo?.isMainland === 'Y' && this.userInfo?.mainlandComplianceAgreed === 'N'
    }
  },
  created() {
    this.getAgreementContentFun()
  },
  methods: {
    changeAboutMargin1 () {
      if (this.ruleForm.aboutMargin[0].checked) {
        Object.assign(this.ruleForm.aboutMargin[0], { accountHolder: '', accountNumber: '' })
      }
    },
    changeAboutMargin2 () {
      if (this.ruleForm.aboutMargin[0].checked) {
        Object.assign(this.ruleForm.aboutMargin[1], { accountHolder: '', accountNumber: '' })
      }
    },
    changeAboutMargin3 () {
      if (this.ruleForm.aboutMargin[0].checked) {
        Object.assign(this.ruleForm.aboutMargin[2], { accountHolder: '', accountNumber: '' })
      }
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$emit('submitForm', { agree: true, relatedMarginAccounts: this.ruleForm.aboutMargin })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 获取常设授权链接
    async getAgreementContentFun() {
      let params = {
        platform: 'H5',
        type: 'Standing_Authority'
      }
      let res = await getAgreementContent(params)
      if (res.code === 200) {
        this.standingLink = res.data && res.data.path
      }
    }
  }

}
</script>
<style lang="scss" scoped>
.article-content{
  .el-checkbox__inner::after {
    height: 12px;
    left: 8px;
    top: 3px;
    width: 3px;
  }
  .el-checkbox__inner {
    width: 22px;
    height: 22px;
  }
  .statement {
    color: #fec000;
    font-size: 16px;
  }
  a {
    text-decoration: none;
  }
  .apply-btn {
    margin-top: 20px;
    .el-button {
      width: 250px;
      height: 56px;
      border-radius: 5px;
      background-color: #fec000;
      color: #182a54;
      font-size: 14px;
      font-weight: 600;
      text-align: center;
      font-family: PingFangSC-Semibold;
    }
  }
}
</style>
